import { Suspense } from "react";
import useAppModernisation from "../../hooks/useAppModernisation";
import TemplateMenu from "./Menu";
import Calculators from "../../features/calculator/calculator";
import ModernCalculators from "../../features/calculator/ModernCalculators";
import NavBar from "../../components/navBar";
import TopicBanner from "../../components/topicBanner";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Router component that switches between app and legacy calculator views
 * based on the current app mode and feature flags
 *
 * Logic:
 * - App mode → TemplateMenu (uses switcher components for individual calculators)
 * - Web mode + CALCULATORS_LEGACY_INTEGRATION=true → Legacy navbar/header + Modern web calculators (Drop 2 hybrid)
 * - Web mode + WEB_MODERNISATION=true + CALCULATORS_LEGACY_INTEGRATION=false → Full modern web calculators (Drop 3)
 * - Web mode + both flags false → Legacy sidebar menu (Calculators component)
 */
const CalculatorRouter = () => {
  const { isAppMode, isWebModernisationEnabled, isCalculatorsLegacyIntegration } = useAppModernisation();
  const location = useLocation();
  const navigate = useNavigate();

  if (isAppMode) {
    return <TemplateMenu />;
  }

  if (isCalculatorsLegacyIntegration) {
    // Drop 2: Legacy header + Modern calculators (hybrid approach)
    return (
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <TopicBanner pathname={location.pathname} search={location.search} push={navigate} />
        <ModernCalculators />
      </Suspense>
    );
  }

  if (isWebModernisationEnabled) {
    // Phase 2: Full modern web calculators (no legacy components)
    return <ModernCalculators />;
  }

  return <Calculators />;
};

export default CalculatorRouter;
